import { compute_data_root_fields } from './get_compute_data';
import {
  customer_panoramic_selection,
  last_transaction_selection,
  promocode_options_selection,
} from './get_customer_last_transaction_promocodes_data';
import {
  first_gateway_details_selection,
  payment_method_groups_panoramic_selection,
} from './get_payment_method_groups_panoramic';

export const get_initial_data_panoramic_query = `
  query Get_initial_data_panoramic($format: PaymentMethodOptionsFormat!, $sort: String, $decline_recovery_type: PaymentMethodOptionsDeclineRecoveryType) {${compute_data_root_fields}
    customer {${customer_panoramic_selection}}
    last_transaction {${last_transaction_selection}}
    promocode_options {${promocode_options_selection}}
    payment_method_groups(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type) {${payment_method_groups_panoramic_selection}}
    first_gateway_details(format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type) {${first_gateway_details_selection}}
  }
`;
